import { selectInfoForTgb } from './selectInfoForTgb';
import { IAppState } from '../../common/state';

export const selectNewbuidingsInfoForTgb = (state: IAppState) => selectInfoForTgb(state).jkInfoForTgbCollection;
